// src/index.js
import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { RouterProvider } from "react-router-dom";
import { QueryClientProvider, QueryClient } from "@tanstack/react-query";
import { SnackbarProvider } from "notistack";
import "./lang/i18n";
import { AuthProvider, useAuth } from "./context";
import { getAccess } from "./permissions/Permissions";
import { createAppRouter } from "./Routes/AppRoutes";
import { NewRecordsProvider } from "./context/NewRecordsProvider";
import { ThemeProvider } from "@emotion/react";
import theme from "./Components/theme/theme";
import useFetchObjects from "./api/useFetchObjects";

const queryClient = new QueryClient({
  defaultOptions: {},
});

const AppWithRouter = () => {
  const auth = useAuth();
  const token = auth?.user?.token;
  const user = auth?.user;

  const { data } = useFetchObjects(
    ["permissions-users"],
    `users/${user?.user?.id}/`,
    token
  );

  const transformPermissions = (data) => {
    if (!data) return {};

    return {
      pharmacy: data.pharmacy || false,
      finance: data.finance || false,
      hr: data.hr || false,
    };
  };

  const permissions = transformPermissions(data);

  const userPermissions = getAccess(permissions, user?.user?.isAdmin);
  const router = createAppRouter(userPermissions);

  return <RouterProvider router={router} />;
};

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <ThemeProvider theme={theme}>
    <AuthProvider>
      <NewRecordsProvider>
        <ToastContainer />
        <QueryClientProvider client={queryClient}>
          <SnackbarProvider>
            <React.StrictMode>
              <AppWithRouter />
            </React.StrictMode>
          </SnackbarProvider>
        </QueryClientProvider>
      </NewRecordsProvider>
    </AuthProvider>
  </ThemeProvider>
);
